import { connect } from "react-redux";
import StaffPage from "./components/StaffPage";
import { Creators as DataCreators } from "../data/reducer";

export default connect(
  state => ({
    rangeLocation: state.login.location
  }),
  dispatch => ({
    onDataReceived: (path, data) =>
      dispatch(DataCreators.dataReceived(path, data))
  })
)(StaffPage);



// WEBPACK FOOTER //
// ./src/staff/index.js